import React from 'react';
import { UserQuery } from './UserQueries.api';
import { MyQuery } from './MyQueries.api';

export const ticketReference = (query: UserQuery) => query.source.toUpperCase() + '-' + query.id;
export const ticketDate = (value: string) => value ? new Date(value).toLocaleString() : '—';
/* Open -> In Progress (both sides can message) -> Resolved (final: no messages, no status changes). */
export const ticketStatuses = {
  Open: 'Query has been submitted and is waiting for the support team.',
  'In Progress': 'The support team is working on your query. You can reply in the conversation.',
  Resolved: 'Your query is resolved. The conversation is closed.',
};
export type TicketStatusName = keyof typeof ticketStatuses;
/** Maps stored values (including the retired 'Awaiting User' and 'Closed') onto the current statuses. */
export function normalizeStatus(value?: string | null): TicketStatusName | undefined {
  const status = value?.trim().toLowerCase();
  if (status === 'awaiting user') return 'In Progress';
  if (status === 'closed') return 'Resolved';
  return (Object.keys(ticketStatuses) as TicketStatusName[]).find(name => name.toLowerCase() === status);
}
export const isFinalStatus = (value?: string | null) => normalizeStatus(value) === 'Resolved';

/* Presentation only: maps each ticket status onto a semantic badge tone. */
export const statusTone: Record<TicketStatusName, string> = {
  Open: 'warning',
  'In Progress': 'info',
  Resolved: 'success',
};

export function TicketStatus({ query }: { query: MyQuery }) {
  // Email delivery state is independent of ticket progress.
  const status = normalizeStatus(query.ticket_status);
  const tone = status ? `zs-badge-${statusTone[status]}` : '';
  return <span title={status ? ticketStatuses[status] : 'No supported ticket status is stored for this query.'} className={`zs-badge zs-badge-dot ${tone} uq-status ticket-${status ? status.toLowerCase().replace(/ /g, '-') : 'unknown'}`}>
    {status || 'Status unavailable'}
  </span>;
}
